export const CLOSETS = 'closest';
export const REGION = 'region';



// WEBPACK FOOTER //
// ./src/components/locator/const/index.js